import { createSelector } from "reselect";

const getMilesPerCurrency = state => state.brand?.milesPerCurrency;
const getMilesPerCurrencyOverrides = state => state.miles?.milesPerCurrency;
const getCurrency = state => state.currency;

const isValidConfig = raw => {
	if (!raw) {
		return false;
	}
	const { currencyAmount, milesAmount } = raw;
	return currencyAmount > 0 && milesAmount !== null && milesAmount !== undefined;
};

// Retourne l'objet brut { currencyAmount, milesAmount } à utiliser pour la shop courante.
// Logique de fallback : override shop pour la devise courante -> valeur brand.
// La devise d'affichage est toujours state.currency (cohérent avec le calcul
// milesCount = price * rate qui s'applique au prix dans la devise de la shop).
export const getMilesPerCurrencyConfig = createSelector(
	[getMilesPerCurrency, getMilesPerCurrencyOverrides, getCurrency],
	(brandMilesPerCurrency, shopOverrides, currency) => {
		const override = Array.isArray(shopOverrides)
			? shopOverrides.find(item => item?.currency === currency)
			: null;

		if (isValidConfig(override)) {
			return {
				currencyAmount: override.currencyAmount,
				milesAmount: override.milesAmount,
			};
		}

		if (isValidConfig(brandMilesPerCurrency)) {
			return {
				currencyAmount: brandMilesPerCurrency.currencyAmount,
				milesAmount: brandMilesPerCurrency.milesAmount,
			};
		}

		return null;
	}
);

// Ratio miles-par-unité-de-devise, utilisé pour calculer le nombre de Miles gagnés.
export const getMilesRatio = createSelector(
	[getMilesPerCurrencyConfig],
	config => {
		if (!config) {
			return null;
		}
		return config.milesAmount / config.currencyAmount;
	}
);
